<template>
  <div class="eleena-data">
    <span style="padding-bottom: 0.5rem" v-if="!products[0]"
      ><i>No product information available for smartmeter</i></span
    >
    <div class="eleena-data" v-else>
      <span><b>Id:</b> {{ products[0].id }}</span>
      <span><b>Description:</b> {{ products[0].description }}</span>
      <span @click="copySerialNumber">
        <b>Serial number:</b>
        <span class="copy-text" ref="serialNumber">{{ products[0].serialNumbers[0] }}</span>
      </span>
    </div>
    <last-week-production
      :serial-number="ticketSerialNumber"
      :postal-code="client.address.postal_code"
      :house-number="client.address.house_number"
    />

    <button
      style="width: 10rem; padding: 0.2rem"
      class="button is-success is-small"
      :class="{ 'is-loading': isLoading }"
      @click="sendCredentials"
    >
      Send credentials
    </button>

    <p v-if="isEmailsLoading">Loading...</p>
    <p v-else-if="emails.length > 0">
      Credentials last send at
      {{ manager.formatDate(new Date(lastEmailSend.mail_timestamp), true) }}
    </p>
    <p v-else><i>No emails send to client</i></p>

  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import request from '@/requests'
import { CallCentreScreenManager } from '@/logic/CallCentreScreen'
import notifications from '@/util/Notifications'
import LastWeekProduction from './LastWeekProduction.vue'
import { currentTicket } from './currentTicket'

@Component({ components: { LastWeekProduction } })
export default class CallCentreEleenaData extends Vue {
  @Prop({}) client!: any
  @Prop({}) manager!: CallCentreScreenManager

  private isLoading = false
  private isEmailsLoading = false

  private emails = []

  get lastEmailSend() {
    return this.emails
      .filter((mail: any) => mail.event_type === 'Delivery' || mail.event_type === 'sent')
      .sort((a: any, b: any) => (a.mail_timestamp > b.mail_timestamp ? -1 : 1))[0]
  }

  public async setEmails() {
    this.isEmailsLoading = true

    const response = await request.eleena.getEmailData(this.manager.query)

    if (response.status_code === 200) {
      this.emails = response.data
    }

    this.isEmailsLoading = false
  }

  public async sendCredentials() {
    this.isLoading = true

    const response = await request.eleena.sendCredentials(this.manager.query)

    if (response.status_code === 200) {
      notifications.addNotification({
        message: response.message,
        type: 'success',
      })

      this.setEmails()
    } else {
      notifications.addNotification({
        message: response.message,
        type: 'danger',
      })
    }

    this.isLoading = false
  }

  public copySerialNumber() {
    const serialNumber = this.products[0].serialNumbers[0]
    const tempElement = document.createElement('input')

    tempElement.value = serialNumber.trim()
    document.body.appendChild(tempElement)
    tempElement.select()

    document.execCommand('copy')
    document.body.removeChild(tempElement)
  }

  private formatProducts(products: any) {
    const newProducts: Array<any> = []

    Object.entries(products).forEach(([type, value]: Array<any>) => {
      if (!value) return

      if (type !== 'smartmeter') return

      Object.entries(value).forEach((prod: Array<any>) => {
        const newProduct = {
          id: '',
          description: '',
          amount: 0,
          serialNumbers: [],
        }

        const { amount } = prod[1]
        const serialNumbers = prod[1].serial_numbers
        const productType = prod[1].description
        const id = prod[0]

        if (productType) {
          newProduct.description = productType
        }
        if (amount) {
          newProduct.amount = amount
        }
        if (serialNumbers) {
          newProduct.serialNumbers = serialNumbers
        }
        if (id) {
          newProduct.id = id
        }

        newProducts.push(newProduct)
      })
    })

    return newProducts
  }

  // the smartmeter serial of the installation ticket, if any
  get ticketSerialNumber() {
    const serial = this.products[0]?.serialNumbers?.[0]
    return serial ? serial.trim() : null
  }

  get products() {
    let products: Array<any> = []

    if (
      !this.client.tasks ||
      !this.client.tasks.installation ||
      !this.client.tasks.installation.tickets
    )
      return products

    // only the current ticket: a cancelled one can carry products that were never installed
    const ticket: any = currentTicket(this.client.tasks.installation.tickets)
    if (ticket?.output?.products) products = this.formatProducts(ticket.output.products)

    return products
  }

  created() {
    this.setEmails()
  }
}
</script>

<style lang="scss" scoped>
.eleena-data {
  display: flex;
  flex-direction: column;

  .copy-text {
    &:hover {
      cursor: pointer;
    }
  }

  & > * {
    b {
      padding-right: 0.3rem;
    }
  }
}
</style>
